import { render, staticRenderFns } from "./RegistrationPlate.vue?vue&type=template&id=85e546bc&scoped=true&"
import script from "./RegistrationPlate.vue?vue&type=script&lang=js&"
export * from "./RegistrationPlate.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationPlate.vue?vue&type=style&index=0&id=85e546bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e546bc",
  null
  
)

export default component.exports